export default __webpack_public_path__ + "static/media/burntodeath1.0b3531ab.png";